<template>
  <v-expansion-panels
    :class="{
      'invoicingFilter white': true,
      'px-3': $vuetify.breakpoint.mdAndDown,
    }"
    v-model="filterExpanded"
  >
    <v-expansion-panel>
      <v-container fluid class="py-0">
        <v-row
          no-gutters
          style="min-height: 76px"
          :class="{
            'fill-height': true,
          }"
        >
          <v-col
            cols="12"
            xl="9"
            lg="9"
            md="9"
            sm="12"
            xs="12"
            :class="{
              'd-flex align-center': true,
              'pt-4': $vuetify.breakpoint.smAndDown,
            }"
          >
            <v-row
              :class="{
                'd-flex flex-column justify-center align-center': $vuetify.breakpoint.xs,
              }"
            >
              <v-col
                sm="6"
                :style="$vuetify.breakpoint.smAndDown ? '' : colFilter.styleMaxWidth"
                :class="{
                  'd-flex align-end': $vuetify.breakpoint.lgAndDown,
                  'd-flex flex-column align-center justify-center': $vuetify.breakpoint.smAndDown,
                }"
              >
                <v-menu ref="competenceMenu" v-model="competenceMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                  <template v-slot:activator="{ on }">
                    <Textfield v-model="invoicingFilterCompetence" label="Competência *" readonly regular hide-details style="width: 100%" v-on="on" />
                  </template>

                  <v-date-picker @click="setCompentence" v-model="competenceDate" type="month" locale="pt-br" color="primary" no-title scrollable>
                    <v-spacer />

                    <v-btn text color="primary" @click="setCompentence"> OK </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            :class="{
              'd-flex flex-row align-center': true,
              'justify-end': $vuetify.breakpoint.mdAndUp,
              'justify-space-between mt-4': $vuetify.breakpoint.smAndDown,
            }"
            cols="12"
            xl="3"
            lg="3"
            md="3"
            sm="12"
            xs="12"
          >
            <div class="ml-2" :style="$vuetify.breakpoint.lgAndUp ? 'width: 270px' : 'width: 100%;'">
              <v-row :style="$vuetify.breakpoint.lgAndUp ? 'width: 290px;' : 'width: 100%;'">
                <v-col
                  :class="{
                    'd-flex align-center': true,
                    'justify-end pr-0': $vuetify.breakpoint.mdAndUp,
                    'justify-center pr-0': $vuetify.breakpoint.smAndDown,
                  }"
                  cols="2"
                >
                  <v-badge :content="counter" color="red" overlap right="20" v-if="counter > 0" class="badgeCounter">
                    <v-icon small color="primary"> fas fa-filter </v-icon>
                  </v-badge>
                </v-col>
                <v-col
                  :class="{
                    'd-flex align-center justify-end px-0': $vuetify.breakpoint.smAndDown,
                  }"
                  cols="10"
                >
                  <span class="primary--text"> Expandir Opções de Pesquisa </span>
                </v-col>
              </v-row>
            </div>

            <v-icon class="expansionIconClass" :style="expansionIconTransition" @click="expand" color="primary" size="30"> mdi-chevron-up </v-icon>
          </v-col>
        </v-row>
      </v-container>

      <v-expansion-panel-content>
        <v-container fluid>
          <v-row no-gutters class="fill-height">
            <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12" class="d-flex align-center">
              <v-row
                :class="{
                  'd-flex justify-center': $vuetify.breakpoint.mdAndDown,
                }"
              >
                <v-col cols="12" md="6" sm="6" :style="$vuetify.breakpoint.lgAndUp ? colFilter.style : ''">
                  <Autocomplete
                    label="Grupo Financeiro"
                    placeholder="Selecione"
                    @change="setFinancialGroup"
                    :value="invoicingFilter.financialGroupId"
                    :items="financialGroups"
                    item-text="name"
                    item-value="id"
                    multiple
                    clearable
                    regular
                    color="primary"
                    item-color="primary"
                    hide-details
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 1" small>
                        <span style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: 50px">{{ item.name }}</span>
                      </v-chip>

                      <span v-if="index === 1" class="grey--text text-caption">
                        {{ formatter.getPluralText("outro", invoicingFilter.financialGroupId) }}
                      </span>
                    </template>
                  </Autocomplete>
                </v-col>

                <v-col cols="12" md="6" sm="6" :style="$vuetify.breakpoint.lgAndUp ? colFilter.style : ''">
                  <Autocomplete
                    label="Contrato"
                    placeholder="Selecione"
                    @change="setContract"
                    :value="invoicingFilter.contractId"
                    :items="contracts"
                    :loading="loadingContracts"
                    item-text="text"
                    item-value="id"
                    multiple
                    clearable
                    regular
                    color="primary"
                    item-color="primary"
                    hide-details
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 1" small>
                        <span style="width: 100px" class="truncate">{{ item.text }}</span>
                      </v-chip>

                      <span v-if="index === 1" class="grey--text text-caption">
                        {{ formatter.getPluralText("outro", invoicingFilter.contractId) }}
                      </span>
                    </template>
                  </Autocomplete>
                </v-col>

                <v-col cols="12" md="6" sm="6" :style="$vuetify.breakpoint.lgAndUp ? colFilter.style : ''">
                  <Autocomplete
                    label="Subcontrato"
                    placeholder="Selecione"
                    @change="setSubContract"
                    :value="invoicingFilter.subContractId"
                    :items="subContracts"
                    :loading="loadingSubContracts"
                    item-text="text"
                    item-value="id"
                    multiple
                    clearable
                    regular
                    color="primary"
                    item-color="primary"
                    hide-details
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 1" small>
                        <span style="width: 100px" class="truncate">{{ item.text }}</span>
                      </v-chip>

                      <span v-if="index === 1" class="grey--text text-caption">
                        {{ formatter.getPluralText("outro", invoicingFilter.subContractId) }}
                      </span>
                    </template>
                  </Autocomplete>
                </v-col>

                <v-col cols="12" md="6" sm="6" :style="$vuetify.breakpoint.lgAndUp ? colFilter.style : ''">
                  <Autocomplete
                    label="Operadora"
                    @change="setInsuranceCarrier"
                    placeholder="Selecione"
                    :value="invoicingFilter.carrierId"
                    :items="insuranceCarriers"
                    item-text="xipp_commercial_name"
                    item-value="id"
                    multiple
                    clearable
                    regular
                    color="primary"
                    item-color="primary"
                    hide-details
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 1" small>
                        <span>{{ item.xipp_commercial_name }}</span>
                      </v-chip>

                      <span v-if="index === 1" class="grey--text text-caption">
                        {{ formatter.getPluralText("outro", invoicingFilter.carrierId) }}
                      </span>
                    </template>
                  </Autocomplete>
                </v-col>

                <v-col cols="12" md="6" sm="6" :style="$vuetify.breakpoint.lgAndUp ? colFilter.style : ''">
                  <Autocomplete
                    label="Benefício"
                    @change="setBenefitFilter"
                    placeholder="Selecione"
                    :value="invoicingFilter.benefitIds"
                    :items="benefits"
                    item-text="name"
                    item-value="id"
                    multiple
                    clearable
                    regular
                    color="primary"
                    item-color="primary"
                    hide-details
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 1" small>
                        <span>{{ item.name }}</span>
                      </v-chip>

                      <span v-if="index === 1" class="grey--text text-caption">
                        {{ formatter.getPluralText("outro", invoicingFilter.carrierId) }}
                      </span>
                    </template>
                  </Autocomplete>
                </v-col>

                <v-col cols="12" md="6" sm="6" :style="$vuetify.breakpoint.lgAndUp ? colFilter.style : ''">
                  <Autocomplete
                    label="Tipo de fatura"
                    placeholder="Selecione"
                    @change="setInvoicingFilter({ invoiceTypeIds: $event })"
                    :value="invoicingFilter.invoiceTypeIds"
                    :items="invoiceTypeIds"
                    item-text="value"
                    item-value="id"
                    multiple
                    clearable
                    regular
                    color="primary"
                    item-color="primary"
                    hide-details
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 1" small>
                        <span>{{ item.value }}</span>
                      </v-chip>

                      <span v-if="index === 1" class="grey--text text-caption">
                        {{ formatter.getPluralText("outro", invoicingFilter.invoiceTypeIds) }}
                      </span>
                    </template>
                  </Autocomplete>
                </v-col>

                <v-col
                  :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'"
                  :class="{
                    'd-flex gap-h-20': true,
                    'justify-center align-center': $vuetify.breakpoint.mdAndDown,
                    'flex-column gap-v-20': $vuetify.breakpoint.smAndDown,
                  }"
                >
                  <v-btn class="white--text" color="primary" :style="btnFilter.style" @click="searchInvoices"> Pesquisar </v-btn>

                  <v-btn class="primary--text" color="background" :style="btnFilter.style" @click="reset"> Limpar Filtros </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import AdvancedSearch from "../../../AdvancedSearch/AdvancedSearch.vue";
import Formatters from "@/shared/formatters/formatters";
import Autocomplete from "../Autocomplete.vue";
import Textfield from "../Textfield.vue";
import moment from "moment";
moment.locale("pt-br");

import InvoicingMixin from "@/shared/mixins/invoicing/invoicingMixin";
import ContractsMixin from "@/shared/mixins/sdi/contractsMixin";
import InvoicingRules from "../../rules/invoicingRules.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "InvoicingFilter",

  components: {
    AdvancedSearch,
    Autocomplete,
    Textfield,
  },

  data: () => ({
    moment,
    formatter: null,

    loadingContracts: false,
    loadingSubContracts: false,
    contracts: [],
    subContracts: [],
    benefits: [],
    invoiceTypeIds: [],

    filterExpanded: null,

    competenceDate: null,
    competenceMenu: false,

    resetAdvancedSearch: false,

    advancedSearchFilters: [
      { id: "name", label: "Nome" },
      { id: "document", label: "CPF" },
    ],
  }),

  mixins: [ContractsMixin, InvoicingMixin, InvoicingRules],

  watch: {
    financialGroups(groups) {
      if (groups && groups.length === 1) {
        this.setFinancialGroup(groups[0].id);
      }
    },

    "invoicingFilter.financialGroupId": {
      async handler(financialGroupId) {
        if (financialGroupId && this.hasInvoicingQueryParameters()) {
          if (this.invoicingFilter.financialGroupId) {
            await this.getContractsByFinancialGroupIdVerifyRhProtegido(this.invoicingFilter.financialGroupId, this.isRHProtegido);
          }
        }
      },
    },

    "invoicingFilter.contractId": {
      async handler(contractId) {
        if (contractId && this.hasInvoicingQueryParameters()) {
          if (this.invoicingFilter.contractId) {
            await this.getSubContractsByContractId(this.invoicingFilter.contractId);

            const contractSelect = this.contracts.find((contract) => contract.id === this.invoicingFilter.contractId);

            if (contractSelect) this.fetchInsuranceCarrierByContract(contractSelect);
          }
        }
      },
    },
  },

  methods: {
    ...mapActions({
      setInvoicingFilter: "invoicing/setInvoicingFilter",
      searchInvoices: "invoicing/search",
      resetFilter: "invoicing/resetFilter",
    }),

    reset() {
      this.resetAdvancedSearch = true;
      if (!this.isRHProtegido) this.contracts = [];
      this.subContracts = [];
      this.resetFilter(this.isRHProtegido);
    },

    resetInvoicingAdvancedSearch() {
      setTimeout(() => {
        this.resetAdvancedSearch = false;
      }, 500);
    },

    async setFinancialGroup(financialGroupId) {
      this.setInvoicingFilter({ financialGroupId: financialGroupId });

      if (!financialGroupId) {
        this.setContract(null);
        this.setSubContract(null);

        this.contracts = [];
        this.subContracts = [];

        return;
      }

      await this.getContractsByFinancialGroupIdVerifyRhProtegido(financialGroupId, this.isRHProtegido);
    },

    async setContract(contractId, contract) {
      this.setInvoicingFilter({ contractId: contractId });

      if (!contractId) {
        this.setSubContract(null);
        this.subContracts = [];

        return;
      }

      if (contract) {
        this.fetchInsuranceCarrierByContract(contract);
      }
    },

    fetchInsuranceCarrierByContract(contract) {
      const contractWithFields = this.formatter.getFilledKeysFromObject(contract);
      const { carrier_id } = contractWithFields;

      if (carrier_id) {
        this.setInsuranceCarrier(carrier_id.id);
      }
    },

    setSubContract(subContractId) {
      this.setInvoicingFilter({ subContractId: subContractId });
    },

    setInsuranceCarrier(carrierId) {
      this.setInvoicingFilter({ carrierId: carrierId });
    },

    setBenefitFilter(benefitIds) {
      this.setInvoicingFilter({ benefitIds: benefitIds });
    },

    setCompentence() {
      if (Boolean(this.competenceDate)) {
        const competenceMonth = parseInt(moment(this.competenceDate, "YYYY-MM").format("MM"));
        const competenceYear = parseInt(moment(this.competenceDate, "YYYY-MM").format("YYYY"));

        this.setInvoicingFilter({
          competenceMonth: competenceMonth,
          competenceYear: competenceYear,
        });
      }

      this.competenceMenu = false;
    },

    expand() {
      if (this.filterExpanded === 0) {
        this.filterExpanded = undefined;

        return;
      }

      this.filterExpanded = 0;
    },
  },

  computed: {
    ...mapGetters({
      counter: "invoicing/invoicingFilterCounter",
      filter: "invoicing/invoicingFilter",
      invoices: "invoicing/invoices",

      insuranceCarriers: "insurance-carrier/insuranceCarriers",
      financialGroups: "financial-group/groups",

      isRHProtegido: "user-info/isRHProtegido",
    }),

    invoicingFilter() {
      return this.filter;
    },

    invoicingFilterSearch: {
      get() {
        return this.filter.document | this.filter.name;
      },

      set(searchs) {
        const name = searchs.find((el) => el.key === "name")?.value[0] ?? null;
        const cpf = searchs.find((el) => el.key === "document")?.value[0] ?? null;
        const cpfFormatted = cpf ? cpf.replace(/\.|-/g, "") : null;

        this.setInvoicingFilter({
          name: name,
          cpf: cpfFormatted,
        });
      },
    },

    invoicingFilterCompetence: {
      get() {
        if (!this.filter.competenceMonth || !this.filter.competenceYear) return null;

        const monthName = moment()
          .month(this.filter.competenceMonth - 1)
          .format("MMMM");
        const monthCapitalized = monthName.charAt(0).toUpperCase() + monthName.slice(1);

        return `${monthCapitalized} ${this.filter.competenceYear}`;
      },

      set(value) {},
    },

    expansionIconTransition() {
      return {
        transform: this.filterExpanded !== 0 ? "rotate(180deg)" : "rotate(0deg)",
        transition: "transform 0.25s",
      };
    },
  },

  created() {
    this.formatter = new Formatters();
  },
};
</script>

<style scoped lang="scss">
.expansionIconClass {
  background-color: transparent !important;
}

.expansionIconClass:after {
  background-color: transparent !important;
}

@keyframes rotate {
  from {
    transform: rotate(360deg);
  }

  to {
    transform: rotate(0deg);
  }
}

.syncSearchTransition {
  transform: 0.5s ease-out;
  animation: rotate 1.2s linear infinite;
}

.invoicingFilter {
  border-radius: 5px !important;
  box-shadow: 0px 3px 6px #00000029;

  > .v-expansion-panel::before {
    box-shadow: none !important;
  }

  > .v-expansion-panel {
    > .v-expansion-panel-content {
      > div {
        padding: 0px !important;
      }
    }
  }

  .v-expansion-panel-content__wrap {
    padding: 0px !important;
  }
}
</style>

<style lang="scss">
.invoicingFilter {
  .v-expansion-panel-content__wrap {
    padding: 0px !important;
  }
}

.badgeCounter {
  > .v-badge__wrapper {
    > .v-badge__badge {
      min-height: 15px !important;
      height: 15px !important;
      min-width: 15px !important;
      width: 15px !important;
      padding: 0px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      left: 10px !important;
      bottom: 10px !important;
    }
  }
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
